import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styles from './index.module.css';
import BalanceChart from './components/BalanceChart';
import BalanceTable from './components/BalanceTable';
import TopOutstanding from './components/TopOutstanding';

const Balance = () => {
  const [activeSection, setActiveSection] = useState('balance');
  const { sidebarOpen } = useOutletContext(); // Get sidebar state from Dashboard
  
  return (
    <div className={`${styles.container} ${sidebarOpen ? styles.sidebarOpen : styles.sidebarClosed}`}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'balance' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('balance')}
          >
            Balance
          </button>
          <button
            className={`${styles.tabButton} ${activeSection === 'topOutstanding' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('topOutstanding')}
          >
            Top Outstanding
          </button>
        </div>

        {activeSection === 'balance' && (
          <div className={styles.sectionContent}>
            <BalanceChart />
            <BalanceTable />
          </div>
        )}

        {activeSection === 'topOutstanding' && (
          <div className={styles.sectionContent}>
            <TopOutstanding />
          </div>
        )}
      </div>
    </div>
  );
};

export default Balance;